class INTENT.utils.InlineMessage

  @code = "inline-message"
  @attr = "data-#{@code}"

  @types:
    error:    'error'
    warning:  'warning'
    info:     'info'
    success:  'success'

  @icons:
    error:    'fa-exclamation-circle'
    warning:  'fa-exclamation-circle'
    info:     'fa-exclamation-circle'
    success:  'fa-check-circle'

  @classes: _.map _.values(@types), (value) => "#{@code}-#{value}"

  @showMessage: (element, type, text) =>
    if type in _.values(@types)
      element = $ element
      tag = element.prop("tagName").toUpperCase()
      if tag in ['INPUT', 'TEXTAREA']
        @clearMessage element

        element
        .attr "#{@attr}-message-type", type
        .removeClass @classes.join ' '
        .addClass "#{@code}-#{type}"

        if text
          icon = $ """
            <i #{@attr}-icon
               class='fa #{@icons[type]} #{@code}-icon #{@code}-#{type}'
               data-toggle='tooltip'
            ></i>
          """
          icon.attr 'title', text
          element.before icon
          INTENT.utils.Tooltip.init icon

  @clearMessage: (element) =>
    element = $ element
    tag = element.prop("tagName").toUpperCase()
    if tag in ['DIV', 'FORM']
      element.find("[#{@attr}-message-type]").each (key, item) =>
        @clearMessage item
    else if tag in ['INPUT', 'TEXTAREA']
      icon = element.prev("[#{@attr}-icon]")
      INTENT.utils.Tooltip.destroy icon
      icon.remove()

      element
        .removeAttr "#{@attr}-message-type"
        .removeClass @classes.join ' '

  @hasError: (element) =>
    return @hasType element, @types.error

  @hasMessage: (element, type) =>
    element = $ element
    has_type = element.attr "#{@attr}-message-type"
    return type is has_type